import { defineStore } from "pinia";
import rvApi from "@/rvapi";
import type {
  Image,
  ImageCategory,
  UploadCategory,
  UploadImage,
} from "@/rvapi";

export const useImageStore = defineStore("images", {
  state: () => ({
    selectedImageCategory: 0,
    categories: [] as ImageCategory[],
    images: [] as Image[],
  }),
  actions: {
    async getImageCategories() {
      this.categories = (await rvApi.getImageCategories()).categories;
      return this.categories;
    },
    async getImageCategory(categoryId: string) {
      return rvApi.getImageCategory(categoryId);
    },
    async saveImageCategory(
      categoryId: string | undefined,
      uploadObj: UploadCategory,
    ) {
      return rvApi.saveImageCategory(categoryId, uploadObj);
    },
    async reorderImageCategories(categoryIds: number[]) {
      await rvApi.reorderImageCategories(categoryIds);
    },
    async getImages(categoryId: number) {
      this.images = (await rvApi.getImages(categoryId)).images;
      return this.images;
    },
    async getImage(imageId: string) {
      return rvApi.getImage(imageId);
    },
    async saveImage(imageId: string | undefined, uploadObj: UploadImage) {
      return rvApi.saveImage(imageId, uploadObj);
    },
    async deleteCollectionImage(imageId: string) {
      await rvApi.deleteCollectionImage(imageId);
    },
    async reorderImages(imageIds: string[]) {
      await rvApi.reorderImages(imageIds);
    },
  },
});
